import { useEffect, useState } from 'react';

import format from 'date-fns/format';

import useFeedPosts from './useFeedPosts';
import { getFeedGroup } from '../../utils/feed';
import uniqueList from '../../utils/uniqueList';
import usePlaylist from '../usePlaylist';

const feedName = 'global_flat';

const usePlaylistPosts = (
  id?: number,
  asset?: number | string,
  activeCategoryId?: number | null | string,
  isDaily?: boolean,
  globalLimit: number = 4,
  globalFeedId?: string,
  userId?: string,
  limit = 4,
) => {
  const [loaded, setLoaded] = useState(false);
  const [day, setDay] = useState<Date | null>(new Date());

  const [feed, setFeed] = useState('');
  const [posts, setPosts] = useState<any>([]);
  const [count, setCount] = useState(0);

  const playlistData = usePlaylist(id || '');
  const feedData = useFeedPosts(
    { name: userId ? 'user' : feedName, id: userId ?? feed },
    '',
    playlistData.data?.ranking,
    limit,
  );
  const feedId = isDaily ? 'playlist-33' : 'global';
  const globalFeedData = useFeedPosts(
    { name: feedName, id: globalFeedId || feedId },
    '',
    '',
    globalLimit,
  );

  useEffect(() => {
    const filters: string[] = [];
    if (asset) {
      filters.push(`asset-${asset}`);
    } else if (activeCategoryId) {
      filters.push(`cat-${activeCategoryId}`);
    }
    if (id) {
      filters.push(`playlist-${id}`);
    }
    if (isDaily) {
      filters.push(`date-${format(day || new Date(), 'yyyy-MM-dd')}`);
    }

    setFeed(getFeedGroup(filters));
  }, [activeCategoryId, day, id, asset, isDaily]);

  useEffect(() => {
    if (feedData.isFetched && globalFeedData.isFetched) {
      const postsData = feedData.data?.pages.map((v) => v?.results).flat() || [];
      const globalPostsData = globalFeedData.data?.pages.map((v) => v?.results).flat() || [];

      setPosts(uniqueList(postsData));
      setCount(postsData.length);

      if ((isDaily && !postsData.length) || playlistData.data?.name === 'New') {
        setPosts(uniqueList(globalPostsData));
        setCount(globalPostsData.length);
      }

      setLoaded(true);
    }
  }, [
    feedData.isFetched,
    globalFeedData.isFetched,
    feed,
    feedData.data,
    globalFeedData.data,
  ]);

  return {
    loaded,
    posts,
    feedData,
    globalFeedData,
    playlistData,
    feed,
    day,
    setDay,
    count,
  };
};

export default usePlaylistPosts;
